// extracted by mini-css-extract-plugin
export default {"root":"c0kQ5tEy","label":"l_Hmbr3f","value":"Uhwh4aUZ","change":"qaaVcGhj","changePositive":"NSCWa3BI","changeNegative":"T8BMlSSk"};